import dashboard from "./dashboard.vue";
/**
 * font name and font size
 * Created by peak on 16/8/18.
 */
export default {
    name: "font",
    icon: "custom-icon font",
    i18n: "font",
    show: true,
    dashboard
}


// WEBPACK FOOTER //
// ./src/components/editor/src/modules/font/index.js